export default {

  setEmpresas(state, payload) {
    state.empresas = payload
  }

}
